import { useTranslation } from "react-i18next";
import { useEffect, useState, useRef, useCallback, Suspense } from "react";

import { CartItem } from "./components/cart";
import _, { sum } from "lodash";
import { toast } from "react-toastify";
import PopupWithHeading from "../../components/popupWithHeading";
import axios from "axios";
import config from '../../configuration/config.json'
import { Price } from "../../components/__simple/_price";
import SimpleButton from "../../components/_input/SimpleButton";
import { useParams } from "react-router-dom";
import Popup from "../../components/popup";
import SMSCheck from "./components/smsCheck";
import { Loading } from "../loading";
import Skeleton from 'react-loading-skeleton'
import { useHistory } from 'react-router-dom';

const SalesOrder = () => {
    const { t: trans, i18n } = useTranslation(["mobileCommon", "mobileHeading", "messages", "new", "error", "info"]);
    let lang = i18n.language;
    const history = useHistory();
    const { number } = useParams();
    const [dataResult, setDataResult] = useState({});
    const [requestData, setRquestData] = useState({});
    const [showPopup, setShowPopup] = useState(false);
    const [optionType, setOptionType] = useState(null);
    const [optionTitle, setOptionTitle] = useState('');
    const [paymentType, setPaymentType] = useState(1);
    const [groupResult, setGroupResult] = useState({});
    const [showFinalPopup, setShowFinalPopup] = useState(false);
    const [showTermsPopup, setShowTermsPopup] = useState(false);
    const [sadadTypes, setSadadTypes] = useState([]);
    const [orderTrans, setOrderTrans] = useState(null);
    const [salesOrder, setSalesOrder] = useState(null);
    const [orderCustInfo, setOrderCustInfo] = useState(null);
    const [orderAuthorized, setOrderAuthorized] = useState(null);
    const [salesOrderAmounts, setSalesOrderAmounts] = useState(null);
    const [sadadInfo, setSadadInfo] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingStatus, setIsLoadingStatus] = useState(false);
    const [termsSalesOrders, setTermsSalesOrders] = useState([]);
    const popRef = useRef(null);
    const handleOption = (type, title) => {
        console.log("handleOption:", title);
        setShowPopup(true);
        setOptionType(type);
        setOptionTitle(title);
    };

    const getIsExpireDate = async (date) => {

        try {

            const date1 = new Date(date);
            const date2 = new Date();
            console.log("date1", date1);
            console.log("date2", date2);
            const diffTime = date1 - date2;
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            console.log(diffTime + " milliseconds");
            console.log(diffDays + " days");

            if (diffDays <= 0 && diffTime <= 0) {
                return true;

            } else {

                return false;
            }

        } catch (error) {
            console.log("error:", error);
            return true

        }

    }



    useEffect(() => {
        FetchDataSalesOrder();

    }, []);

    const [salesOrderStatusCode, setSalesOrderStatusCode] = useState("");
    const FetchDataSalesOrder = async () => {

        await callPaymentStatus();

        console.log('FetchDataSalesOrder>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>');
        try {
            axios.request({
                url: config.controllerUrl + 'api/SalesOrder/FetchSalesOrderData',
                data: { guid: number }, method: "POST", responseType: "json"
            })
                .then(async function (response) {
                    console.log("setSalesOrder:", response.data);
                    setSalesOrder(response.data[0]);
                    var expirdate = await getIsExpireDate(response?.data[0]?.Expirdate)
                    console.log("expirdate:", expirdate);
                    if (expirdate) {
                        setSalesOrderStatusCode("expired");
                        setShowFinalPopup(true);
                    } else {

                        if (response.data[0].CustPaymentMethodEN == "Finance" || response.data[0].CustPaymentMethodEN == "Cash By Branch") {

                            setSalesOrderStatusCode(response.data[0].CustPaymentMethodEN);
                            setShowFinalPopup(true);

                        } else {


                            if (response.data[0].SalesOrderStatusID == "Ready for payment") {
                                setSalesOrderStatusCode("ready");
                                PaymentStatus();

                            } else if (response.data[0].SalesOrderStatusID == "Canceled") {
                                setSalesOrderStatusCode("canceled");
                                setShowFinalPopup(true);

                            } else if (response.data[0].SalesOrderStatusID == "Confirmed") {
                                setSalesOrderStatusCode("confirmed");
                                PaymentStatus();


                            } else {
                                setSalesOrderStatusCode("notCorrect");
                                setShowFinalPopup(true);
                            }

                        }

                    }

                })
                .catch(function (error) {
                    setSalesOrderStatusCode("notFound");
                    setShowFinalPopup(true);
                    console.log(error);
                });
        } catch (error) {
            console.log("error:", error);
        }

    }


    const SiteSendSdadCodeFormAppFunction = async (sadad, mobile) => {

        try {
            axios.request({
                url: config.controllerUrl + 'api/SalesOrder/SendSadadCode',
                data: { to: "966" + mobile, body: sadad }, method: "POST", responseType: "json"
            })
                .then(async function (response) {
                    console.log("Fetch_DataSalesOrderApp:", response);

                })
                .catch(function (error) {
                    console.log(error);
                });
        } catch (error) {
            console.log("error:", error);
        }

    }

    const updatePaymentMethod = async (paymentMethodID, PaymentTypeID) => {
        setIsLoading(true);
        await axios.request({
            baseURL: config.controllerUrl,
            url: "sadad/api/sadad/updatePaymentMethod",
            params: {
                GUID: number,
                paymentMethodID: paymentMethodID,
                PaymentTypeID: PaymentTypeID
            },
            method: "put",
        }).then(response => {
            console.log("updatePaymentMethod response:", response);

            setIsLoading(false);
            return response?.data;
        }).catch(error => {
            console.log(error);
            setIsLoading(false);
            return false;
        })

    }

    const FetchSadadNumberApp = async () => {
        try {
            await axios.request({
                url: config.controllerUrl + 'api/SalesOrder/FetchSadadNumber',
                data: { guid: number }, method: "POST", responseType: "json"
            })
                .then(async function (response) {
                    console.log("setSadadInfo:", response?.data);


                    try {
                        var sadadNumber = response.data[0].sadadNumber.replaceAll('"', "");
                        console.log("sadadNumber:", sadadNumber);
                        if (sadadNumber && parseInt(sadadNumber)) {
                            var datasadad = response.data[0];
                            datasadad.sadadNumber = sadadNumber;
                            setSadadInfo(datasadad);
                        } else {

                            setSadadInfo(response?.data[0]);
                        }


                    } catch (error) {
                        setSadadInfo(response?.data[0]);
                        console.log("error sadadNumber:", error);
                    }

                    if (response.data[0].sadadNumber != null && response.data[0].sadadNumber != undefined) {

                        setShowFinalPopup(true);
                    } else {
                        await callback();
                    }

                })
                .catch(function (error) {

                    console.log(error);
                });
        } catch (error) {

            console.log("error:", error);
        }
    };

    const callback = useCallback(async () => {


        setIsLoadingStatus(true)
        try {
            axios.request({
                url: config.controllerUrl + 'api/SalesOrder/FetchSalesOrderTrans',
                data: { guid: number }, method: "POST", responseType: "json"
            })
                .then(function (response) {
                    console.log("Fetch_SalesOrderTrans:", response);
                    setOrderTrans(response.data);
                    setIsLoadingStatus(false)

                })
                .catch(function (error) {
                    console.log(error);
                    setIsLoadingStatus(false)
                });
        } catch (error) {
            setIsLoadingStatus(false)
            console.log("error:", error);
        }

        try {
            axios.request({
                url: config.controllerUrl + 'api/SalesOrder/FetchCustInfo',
                data: { guid: number }, method: "POST", responseType: "json"
            })
                .then(function (response) {
                    console.log("setOrderCustInfo:", response);
                    setOrderCustInfo(response.data);


                })
                .catch(function (error) {

                    console.log(error);
                });
        } catch (error) {

            console.log("error:", error);
        }


        try {
            axios.request({
                url: config.controllerUrl + 'api/SalesOrder/FetchAuthorized',
                data: { guid: number }, method: "POST", responseType: "json"
            })
                .then(function (response) {
                    console.log("setOrderAuthorized:", response);
                    setOrderAuthorized(response.data);


                })
                .catch(function (error) {

                    console.log(error);
                });
        } catch (error) {

            console.log("error:", error);
        }

        try {
            axios.request({
                url: config.controllerUrl + 'api/SalesOrder/FetchAmounts',
                data: { guid: number }, method: "POST", responseType: "json"
            })
                .then(function (response) {
                    console.log("setSalesOrderAmounts:", response);
                    setSalesOrderAmounts(response.data[0]);


                })
                .catch(function (error) {

                    console.log(error);
                });
        } catch (error) {

            console.log("error:", error);
        }


        try {
            axios.request({
                url: config.controllerUrl + 'api/SalesOrder/GetTermsByGuid',
                data: { guid: number }, method: "POST", responseType: "json"
            })
                .then(function (response) {
                    console.log("fetch_termsSalesOrders:", response);
                    setTermsSalesOrders(response.data);

                })
                .catch(function (error) {
                    console.log(error);
                });
        } catch (error) {
            console.log("error:", error);
        }

    }, []);

    const handelGoCheckSms = () => {

        // onSucess();
        if (!isLoading) {
            if (sadadInfo?.sadadNumber) {
                setShowFinalPopup(true);
                toast.success(trans("new:a_payment_number_has_already_been_created"));
                return
            }

            if (salesOrderStatusCode == "ready") {
                if (paymentType) {

                    setShowPopup(true);
                } else {
                    toast.error(trans("new:please_define_pay_method"));

                }
            }
        }


    }

    //PaymentMAin
    async function PayTabs() {

        setIsLoading(true);
        try {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            var raw = {
                "GUID": number,
                "Callback": window.location.origin + "/" + lang + "/salesOrder/"
            };
            axios.request({
                baseURL: config.controllerUrl,
                url: "sadad/api/sadad/PayTabs",
                headers: myHeaders,
                data: raw, method: "POST", responseType: "json"
            }).then(response => {
                console.log('PayTabs respons:', response);
                try {

                    if (response?.data?.URL_Paytabs)
                        window.location.href = response.data.URL_Paytabs;
                    else {
                        toast.error(trans("error:unknown_failure"));
                    }
                    // history.push(response.data.URL_Paytabs);
                } catch (error) {
                    toast.error(trans("error:unknown_failure"));
                }

                setIsLoading(false);
            }
            ).then((response) => {
                console.log('response2', response);
                setIsLoading(false);
            }).catch(error => {
                console.log('erro PayTabs', error)
                setIsLoading(false);
                toast.error(trans("error:unknown_failure"));


            });
        } catch (error) {
            console.log('error PayTabs', error)
            setIsLoading(false);
            toast.error(trans("error:unknown_failure"));

        }


    }


    //PaymentMAin for changes
    async function callPaymentStatus() {
        console.log('callPaymentStatus>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>');
        setIsLoadingStatus(true);
        try {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            var raw = {

                "GUID": number
            };

            await axios.request({
                baseURL: config.controllerUrl,
                url: "sadad/api/sadad/PaymentStatus",
                headers: myHeaders,
                data: raw, method: "POST", responseType: "json"
            }).then(async response => {
                console.log('PaymentStatus respons:', response.data);

                setIsLoadingStatus(false);
            }
            ).then((response) => {
                console.log('response2', response);
            }).catch(async error => {
                console.log('error PaymentStatus:', error)
                setIsLoadingStatus(false);
            });
        } catch (error) {
            console.log('error', error)
            setIsLoadingStatus(false);

        }


    }

    async function PaymentStatus() {

        setIsLoadingStatus(true);
        try {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            var raw = {

                "GUID": number
            };

            await axios.request({
                baseURL: config.controllerUrl,
                url: "sadad/api/sadad/PaymentStatus",
                headers: myHeaders,
                data: raw, method: "POST", responseType: "json"
            }).then(async response => {
                console.log('PaymentStatus respons:', response.data);


                try {
                    var sadadNumber = response.data.sadadNumber.replaceAll('"', "");
                    if (sadadNumber && parseInt(sadadNumber)) {
                        var datasadad = response.data;
                        datasadad.sadadNumber = sadadNumber;
                        setSadadInfo(datasadad);
                        //-----------------------------
                        console.log('sadadNumber respons:', sadadNumber);
                        try {
                            axios.request({
                                url: config.controllerUrl + 'api/SalesOrder/FetchCustInfo',
                                data: { guid: number }, method: "POST", responseType: "json"
                            })
                                .then(function (response) {
                                    console.log("setOrderCustInfo:", response);
                                    SiteSendSdadCodeFormAppFunction(sadadNumber, response?.data[0].Mobile);

                                })
                                .catch(function (error) {

                                    console.log(error);
                                });
                        } catch (error) {

                            console.log("error:", error);
                        }


                        //-------------------------------
                    } else {

                        setSadadInfo(response?.data);
                    }


                } catch (error) {
                    setSadadInfo(response.data);
                    console.log("error sadadNumber:", error);
                }

                if (response.data.sadadNumber != null && response.data.sadadNumber != undefined) {

                    setShowFinalPopup(true);
                } else {
                    await callback();

                }



                setIsLoadingStatus(false);
            }
            ).then((response) => {
                console.log('response2', response);

            }).catch(async error => {
                console.log('error PaymentStatus:', error)

                await FetchSadadNumberApp();
                console.log('after FetchSadadNumberApp');
                setIsLoadingStatus(false);

            });
        } catch (error) {
            console.log('error', error)
            await FetchSadadNumberApp();
            setIsLoadingStatus(false);

        }


    }
    const onSucess = async () => {

        if (!isLoading) {
            setShowPopup(false);

            // const isLagout = window.confirm(trans("new:are_you_sure_you_have_completed_the_payment_process"));
            console.log("paymentType:", paymentType);

            if (paymentType == 1) {
                PayTabs();
            } else if (paymentType == 2) {
                var val = await updatePaymentMethod("Financing", "Credit");

                // if (val) {
                    window.location.reload(true);
                // } else {
                //     toast.error(trans("error:unknown_failure"));
                // }
            } else {
                var val = await updatePaymentMethod("CashByBranch", "Cash");
                // if (val) {
                    window.location.reload(true);
                // } else {
                //     toast.error(trans("error:unknown_failure"));
                // }

            }



            // if (salesOrder?.CustPaymentMethodEN != paymentType?.CustPaymentMethodID) {
            //     try {
            //         const settingResponse = await axios.request({
            //             baseURL: '/',
            //             url: lang + "/api/Sadad/index",
            //             method: "get"
            //         });

            //         setSadadTypes(settingResponse.data.brands);

            //     } catch (error) {
            //         console.log(error);
            //     }



            // }
            // try {
            //     const Body = {
            //         "Object": "SalesOrders",
            //         "CommandName": "SalesMntc_CreateSadadInfoSO",

            //         "Values":
            //         {
            //             "Guid": number

            //         }
            //     }
            //     axios.request({
            //         url: config.baseURLSadad + 'Action',
            //         data: Body, method: "POST", responseType: "json"
            //     })
            //         .then(function (response) {
            //             //---------------------------------------------------
            //             const Body = {
            //                 "Object": "SalesOrders",
            //                 "CommandName": "SalesMntc_CreateSadadCodeSO",

            //                 "Values":
            //                 {
            //                     "Guid": number

            //                 }
            //             }
            //             axios.request({
            //                 url: config.baseURLSadad + 'Action',
            //                 data: Body, method: "POST", responseType: "json"
            //             })
            //                 .then(function (response) {
            //                     FetchSadadNumberApp();
            //                     setSadadInfo(response.data);

            //                     setShowFinalPopup(true);
            //                 })
            //                 .catch(function (error) {
            //                     toast.error(" حدث خطاء غير متوقع");
            //                     console.log(error);
            //                 });
            //             //----------------------------------------------------
            //         })
            //         .catch(function (error) {
            //             toast.error(" حدث خطاء غير متوقع");
            //             console.log(error);
            //         });
            // } catch (error) {
            //     toast.error(" حدث خطاء غير متوقع");
            //     console.log("error:", error);
            // }


        }
    }


    const popupSectionCallback = useCallback(() => {

        console.log("popupSectionCallback:", salesOrderStatusCode)
        console.log(" sadadInfo?.sadadNumber:", sadadInfo?.sadadNumber)
        let fragment = <></>;
        switch (salesOrderStatusCode) {
            case "confirmed":
                fragment =
                    salesOrder?.SalesOrderID &&
                    <>
                        <div className="flex flex-row justify-center">
                            <span className="text-34 font-bold text-gray mx-2"> {trans("new:sales_order_number")}</span>
                            <span className="text-34 font-bold text-gray mx-2">{salesOrder && salesOrder?.SalesOrderID}</span>
                        </div>

                        {
                            salesOrderAmounts?.PaidAmount &&
                            <>
                                <div className="flex flex-col items-center nice-gap-2rem">
                                    <span className="text-34 font-bold text-gray mx-2"> {trans("new:to_avoid_order_cancellation")} </span>
                                    <span className="text-40 font-bold text-primary mx-2">{salesOrderAmounts?.NetTotalAfterDisc && <Price price={salesOrderAmounts?.NetTotalAfterDisc - salesOrderAmounts?.PaidAmount} />} </span>
                                </div>
                                <div className="flex flex-row justify-center mb-10">
                                    <span className="text-34 font-bold text-gray mx-2">{trans("new:by")}</span>
                                    <span className="text-34 font-bold text-note mx-2"><img src={"/assets/logo/SADAD-Logo-400x143.png"} alt={"sadad"} /></span>
                                    <span className="text-34 font-bold text-gray mx-2">{trans("new:within_24_hours")}</span>
                                </div>
                            </>

                        }


                        {
                            sadadInfo?.sadadNumber &&
                            <div className="cart-finalized-code"

                                onClick={() => {

                                    navigator.clipboard.writeText(sadadInfo?.sadadNumber ? sadadInfo?.sadadNumber : "");
                                    toast.success(trans("messages:copied_successfully"));
                                }}
                            >
                                <span className="text-34 font-bold text-white mx-2"> {trans("new:sadad")}</span>
                                <code className="text-white text-30">{sadadInfo?.sadadNumber ? sadadInfo?.sadadNumber : ""}</code>
                                <img src="/assets/icons/copy.svg" alt='copy' />
                            </div>
                        }
                    </>

                break;

            case "Finance":
                fragment =
                    <div className="flex flex-row justify-center">
                        <span className="text-34 font-bold text-gray mx-2"> {trans("new:sales_order_number")}</span>
                        <span className="text-34 font-bold text-gray mx-2">{salesOrder && salesOrder?.SalesOrderID}</span>
                    </div>
                break;

            case "Cash By Branch":
                fragment =
                    <>
                        <div className="flex flex-row justify-center">
                            <span className="text-34 font-bold text-gray mx-2"> {trans("new:sales_order_number")}</span>
                            <span className="text-34 font-bold text-gray mx-2">{salesOrder && salesOrder?.SalesOrderID}</span>
                        </div>
                        <div className="flex flex-row justify-center mb-10">
                            <span className="text-34 font-bold text-gray mx-2">{trans("new:message_By_Branch")}</span>
                        </div>
                    </>
                break;

            case "canceled":
                fragment =
                    <div className="flex flex-row justify-center mb-10">
                        <span className="text-34 font-bold text-gray mx-2">{trans("new:agreement_link_is_cancelled")}</span>
                    </div>
                break;
            case "notCorrect":
                fragment =
                    <div className="flex flex-row justify-center mb-10">
                        <span className="text-34 font-bold text-gray mx-2">{trans("new:agreement_status_is_invalid")}</span>
                    </div>
                break;
            case "notFound":
                fragment =
                    <div className="flex flex-row justify-center mb-10">
                        <span className="text-34 font-bold text-gray mx-2">{trans("new:agreement_link_is_incorrect")}</span>
                    </div>
                break;
            case "expired":
                fragment =
                    <div className="flex flex-row justify-center mb-10">
                        <span className="text-34 font-bold text-gray mx-2">{trans("new:agreement_link_has_expired")}</span>
                    </div>
                break;
        }
        return fragment

    }, [salesOrderStatusCode, sadadInfo]);

    return (

        isLoadingStatus ? (

            // <Loading />

            <>
                <Skeleton count={1} borderRadius={"1rem"} width={"100%"} height={"10rem"}
                    containerClassName={"my-5"} className={"flex my-5"} inline={false} />

                <Skeleton count={1} borderRadius={"1rem"} width={"100%"} height={"50rem"}
                    containerClassName={"my-5"} className={"flex my-5"} inline={false} />

                <Skeleton count={1} borderRadius={"1rem"} width={"100%"} height={"50rem"}
                    containerClassName={"my-5"} className={"flex my-5"} inline={false} />

                <Skeleton count={10} borderRadius={"1rem"} width={"70%"} height={"5rem"}
                    containerClassName={"my-5"} className={"flex my-5"} inline={false} />

                <Skeleton count={2} borderRadius={"1rem"} width={"50%"} height={"10rem"}
                    containerClassName={"flex flex-row nice-gap-2rem my-20"} className={"flex flex-row nice-gap-2rem my-20"} inline={true} />
            </>


        ) : (
            < div className=" unselectable ">

                <section className="cart  h-full  ">
                    <div className=" p-10 bg-black text-white">
                        <div className="sales-header">
                            <img src="/assets/logo/HassanJ-LOGO_white.svg" alt='discount' className="" />

                            <h2 className="text-40 py-5 text-white text-center font-bold nice-apply-theme text-capitalize">{trans("new:sales_agreement")}</h2>

                            <div className={"change-lang text-bold text-24"}
                                onClick={() => {
                                    // i18next.changeLanguage(trans("mobileCommon:changeLangCode")).then((r) => {
                                    // });
                                    //
                                    var bb = (window.location.pathname.includes("/en") || window.location.pathname.includes("/ar")) ? window.location.href.replace(/en|ar/, trans("mobileCommon:changeLangCode"))
                                        : window.location.origin + "/" + trans("mobileCommon:changeLangCode") + window.location.pathname;
                                    console.log("......:", bb)
                                    window.location = bb;
                                }}>{trans("mobileCommon:changeLang")}
                                {/* <img src="/assets/icons/globle.svg" alt="change language" /> */}

                            </div>

                        </div >


                    </div >
                    {
                        (orderTrans?.length > 0) &&
                        <div className="my-10 pb-10">
                            {
                                orderTrans?.map((item, index) => {
                                    return (
                                        <CartItem
                                            key={index}
                                            id={item.GUID}
                                            cartType={'car'}
                                            brand={lang == "ar" ? item.BrandAr : item.BrandEn}
                                            image={item.CarImage}
                                            title={lang == "ar" ? item.GroupsAr : item.GroupsEn}
                                            description={lang == "ar" ? item.DescriptionAr : item.DescriptionEn}
                                            model={item.Model}
                                            subTitle={lang == "ar" ? item.ColorDescAr : item.ColorDescEn}
                                            count={item.Qty}
                                            oldPrice={item.Discount}
                                            price={item.Amount}
                                            agreementShow={true}
                                            orderAuthorized={orderAuthorized && orderAuthorized[0]}
                                            orderCustInfo={orderCustInfo && orderCustInfo[0]}
                                            salesOrder={salesOrder && salesOrder}
                                            orderTrans={item}
                                            showCountBtun={false}
                                            isShowInfo={true}


                                        />
                                    )
                                })

                            }
                        </div>
                    }


                    {


                        salesOrderAmounts &&

                        <>
                            <div className=" my-10">
                                <div className="flex flex-col nice-gap-2rem">
                                    <div className="flex flex-row justify-between items-center nice-container">
                                        <h3 className="text-40 font-bold text-black"> {trans("new:pay_method")}</h3>

                                    </div>

                                    {/* {
                                    sadadTypes?.map((item, index) => {
                                        return (
                                            <label key={index} className={" text-30 font-bold flex flex-row nice-gap-1rem mb-10 " + (paymentType?.CustPaymentMethodID == item?.CustPaymentMethodID ? "bg-gray-light p-10" : "")}>
                                                <input type='radio' checked={paymentType?.CustPaymentMethodID == item?.CustPaymentMethodID ? true : false} name='paymentType'
                                                    onClick={() => {

                                                        setPaymentType(item);
                                                    }}

                                                /> {lang == "ar" ? item?.DescriptionAr : item?.DescriptionEn}</label>
                                        )
                                    })
                                } */}

                                    <div className={"flex flex-col nice-gap-2rem  nice-container p-5 " + (paymentType == 1 ? "bg-gray-light " : "")}>
                                        <label className={" text-30 font-bold flex flex-row nice-gap-1rem "}>
                                            <input type='radio' checked={paymentType == 1 ? true : false} name='paymentType'
                                                onClick={() => {
                                                    setPaymentType(1);
                                                }}

                                                onChange={() => {


                                                }}
                                                id="primary"


                                                disabled={sadadInfo?.sadadNumber ? true : false}
                                            />
                                            {trans("new:online_batch") + " " + trans("new:and_the_rest_via_SADAD")}

                                        </label>
                                        <div className="flex flex-row items-center  mx-10">
                                            <img className="cart-payment-icon object-contain" src="/assets/icons/companies/master-card-3.png" alt={"master"} />
                                            <img className="cart-payment-icon object-contain" src="/assets/icons/companies/visa-3.png" alt={"visa"} />
                                            <img className="cart-payment-icon object-contain" src="/assets/icons/companies/mada-3.png" alt={"mada"} />
                                            <img className="cart-payment-icon object-contain" src={"/assets/icons/companies/SADAD-Logo.png"} alt={"SADAD"} />

                                            {/* {
                                    sadadInfo?.sadadNumber &&
                                    <div className="cart-finalized-code"
                                        onClick={() => {

                                            navigator.clipboard.writeText(sadadInfo?.sadadNumber ? sadadInfo?.sadadNumber : "");
                                        }}
                                    >
                                        <code className="text-white text-30">{sadadInfo?.sadadNumber ? sadadInfo?.sadadNumber : ""}</code>
                                        <img src="/assets/icons/copy.svg" alt='copy' />
                                    </div>


                                } */}
                                        </div>

                                    </div>


                                    <div className={"flex flex-col nice-gap-2rem  p-5 nice-container " + (paymentType == 2 ? "bg-gray-light my-10" : "")}>
                                        <label className={" text-30 font-bold flex flex-row nice-gap-1rem "}>
                                            <input type='radio' checked={paymentType == 2 ? true : false} name='paymentType'
                                                onClick={() => {

                                                    setPaymentType(2);
                                                }}
                                                onChange={() => {

                                                }}

                                                id="primary"
                                                disabled={sadadInfo?.sadadNumber ? true : false}
                                            />

                                            {trans("new:by_finance")}

                                        </label>
                                    </div>

                                    <div className={"flex flex-col nice-gap-2rem  p-5 nice-container " + (paymentType == 3 ? "bg-gray-light my-10" : "")}>
                                        <label className={" text-30 font-bold flex flex-row nice-gap-1rem "}>
                                            <input type='radio' checked={paymentType == 3 ? true : false} name='paymentType'
                                                onClick={() => {

                                                    setPaymentType(3);
                                                }}
                                                onChange={() => {

                                                }}
                                                id="primary"
                                                disabled={sadadInfo?.sadadNumber ? true : false}
                                            />
                                            {trans("new:by_branch")}

                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div className="flex flex-column bg-secondary-light items-center nice-shadow-2 my-5">
                                {/* <Coupon priceOff={TotalDiscount}

                        onSubmit={(codeValue) => {
                            applyCoupon(codeValue);
                        }}

                        onReset={() => {
                            setClearCoupont(false);
                            SetTotalDiscount(0);
                            setCouponDetail(null);
                        }}

                    />
                    <ShippingOff
                        offer="انفق 160 ريال إضافيا للتاهل للشحن المجاني"
                        successMessage={"مبروك لقد استحقت طلبيات الشحن المجاني"}
                        onClick={() => {

                        }}
                    /> */}

                            </div>



                            <div className="cart-container">

                                <section className="cart-bill bg-white nice-container">
                                    <div className="text-30 mb-20"

                                        onClick={() => {
                                            setShowTermsPopup(true);
                                        }}
                                    >
                                        {trans("mobileCommon:cart_agreement_part1")}&nbsp;
                                        <span className="text-info-light text-30 mx-1">{trans("mobileCommon:cart_agreement_part2")}</span>
                                        {trans("mobileCommon:cart_agreement_part3")}
                                    </div>
                                    <div className="cart-bill-row">
                                        <span className=" cart-bill-row-item text-capitalize">{trans("mobileCommon:tax") + " (15%) "}</span>
                                        <span className="cart-bill-row-item text-bold"><Price price={salesOrderAmounts?.NetTotalExclTax * (0.15)} /></span>
                                    </div>
                                    <div className="cart-bill-row ">
                                        <span className=" cart-bill-row-item text-capitalize">{trans("mobileCommon:plates_cost")}</span>
                                        <span className="cart-bill-row-item text-bold"><Price price={(salesOrderAmounts?.NetTotalAfterDisc + salesOrderAmounts?.DiscountTotal) - ((salesOrderAmounts?.NetTotalExclTax * (0.15)) + salesOrderAmounts?.NetTotalExclTax)} /></span>
                                    </div>
                                    <div className="cart-bill-row">
                                        <span className=" cart-bill-row-item text-capitalize">{trans("mobileCommon:full_total")}</span>
                                        <span className="cart-bill-row-item text-bold"><Price price={salesOrderAmounts?.NetTotalExclTax} /></span>
                                    </div>

                                    <div className="cart-bill-row ">
                                        <span className=" cart-bill-row-item text-capitalize">{trans("mobileCommon:discount")}</span>
                                        <span className="cart-bill-row-item text-bold"><Price price={salesOrderAmounts?.DiscountTotal} showZero={true} /></span>
                                    </div>

                                    {
                                        salesOrderAmounts?.PaidAmount &&
                                        <div className="cart-bill-row ">
                                            <span className=" cart-bill-row-item text-bold text-capitalize">{trans("mobileCommon:paid_amount")}</span>
                                            <span className="cart-bill-row-item text-bold"><Price price={salesOrderAmounts?.PaidAmount} /></span>
                                        </div>
                                    }




                                    <div className="border-line "></div>

                                    <div className="cart-bill-row my-10">
                                        <span className="font-bold text-super-gray">{trans("mobileCommon:total")}</span>
                                        <div className="flex flex-row">
                                            <span className="text-30 cart-bill-row-item mx-2">{trans("mobileCommon:tax_note")}</span>
                                            <span className="text-30 cart-bill-row-item text-bold"><Price price={salesOrderAmounts?.NetTotalAfterDisc - salesOrderAmounts?.PaidAmount} /></span>
                                        </div>
                                    </div>

                                    <div className="cart-bill-line my-4"></div>
                                    <div className="cart-bill-row">
                                        <span className="text-bold text-black">{trans("new:online_batch")}</span>
                                        <div className="flex flex-row">
                                            <span className="text-30  text-bold text-black"><Price price={salesOrderAmounts?.ReqDownPayment} /></span>
                                        </div>
                                    </div>
                                    <div className="cart-bill-row">
                                        <span className="text-bold text-black">{trans("new:and_the_rest_via_SADAD")}</span>
                                        <div className="flex flex-row">
                                            <span className="text-30  text-bold text-black"><Price price={(salesOrderAmounts?.NetTotalAfterDisc - salesOrderAmounts?.PaidAmount) - salesOrderAmounts?.ReqDownPayment} /></span>
                                        </div>
                                    </div>


                                    <div className="flex flex-row nice-gap-2rem my-20" dir="rtl">
                                        <SimpleButton
                                            className="text-white bg-primary  basis-2/4 my-10 order-1"

                                            isLoading={isLoading}
                                            title={trans("complete_the_order")}
                                            onClick={() => {

                                                handelGoCheckSms();
                                                // if (onClick) {
                                                //     onClick();
                                                // }
                                            }}
                                        />

                                        <SimpleButton
                                            className="text-white bg-black basis-2/4 my-10"
                                            iconPath={'/assets/icons/apple-pay.png'}
                                            onClick={() => {
                                                // setShowFinalPopup(true);
                                                // window.location.replace("https://secure.paytabs.sa/payment/request/invoice/1288115/B2C960375A1C475BBF7C70216CB629A9");
                                            }}
                                        />
                                    </div>
                                </section>
                            </div>
                        </>
                    }


                </section >
                <Suspense>


                    <PopupWithHeading
                        className={"popup-container-auto"}
                        backButton={true}
                        show={showPopup}
                        title={optionTitle}
                        onStatusChange={(status) => {

                            setShowPopup(false);
                        }}
                    >
                        <SMSCheck
                            mobile={orderCustInfo && orderCustInfo[0]?.Mobile}

                            onSucess={onSucess}

                        />
                    </PopupWithHeading>


                    <Popup show={showFinalPopup}>
                        <div className="w-full h-full flex justify-center items-center" >
                            <div className="cart-finalized" ref={popRef}>
                                {/* <div className="popup-close nice-select-none" onClick={() => {

                                setShowFinalPopup(false);

                            }}>
                                {"x"}
                            </div> */}
                                <div className="cart-finalized-container">
                                    <img src="/assets/images/finalized.svg" />
                                </div>
                                <div className="flex flex-wrap justify-center">
                                    <span className="text-34 font-bold text-black mx-2 unselectable ">{trans("new:thank_to_choose")}</span>
                                    <span className="text-34 font-bold text-primary mx-2"> {trans("new:HJ_cars")}</span>
                                </div>
                                {
                                    popupSectionCallback()
                                }
                            </div>
                        </div>
                    </Popup>



                    <Popup show={showTermsPopup}>
                        <div className="w-full h-full flex justify-center items-center" >
                            <div className="cart-finalized" ref={popRef}>
                                <div className="popup-close nice-select-none" onClick={() => {

                                    setShowTermsPopup(false);

                                }}>
                                    {"x"}
                                </div>



                            </div>
                        </div>
                    </Popup>

                    <PopupWithHeading
                        terms={true}
                        backButton={false}
                        show={showTermsPopup}
                        title={trans("mobileCommon:cart_agreement_part2")}
                        onStatusChange={(status) => {
                            setShowTermsPopup(false);
                        }}


                    >

                        <div className="my-20 p-5 flex flex-col top-margin-t">
                            {
                                termsSalesOrders[0] &&
                                <img src={(lang == "ar" ? termsSalesOrders[0].imageAr : termsSalesOrders[0].imageEn) ? "data:image/png;base64," + (lang == "ar" ? termsSalesOrders[0].imageAr : termsSalesOrders[0].imageEn) : '/assets/images/default.png'} alt={""} />
                            }
                        </div>


                    </PopupWithHeading>
                </Suspense>
            </div>

        )

    )
};
export default SalesOrder;